import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const BellIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('BellIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.777 14.739c-.458.44-1.085.71-1.777.71a2.56 2.56 0 0 1-1.776-.71m8.17-2.132H1.606a2.83 2.83 0 0 0 1.777-2.624V6.568a4.618 4.618 0 0 1 9.237 0v3.415c0 1.156.703 2.195 1.776 2.624"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
BellIcon.id = 'BellIcon';
BellIcon.displayName = 'BellIcon';
export default BellIcon;
